import Footer from "./Footer";
import NavBar from "./NavBar";

const PublicLayout = ({ children }) => {
  return (
    <>
      <NavBar />
      {children}
      <Footer />
    </>
  );
};

export default PublicLayout;
